var M=(H=>(H.MP="MP",H.SHOP="SHOP",H))(M||{});export{M as a};
